import { render } from "./OtherBill.vue?vue&type=template&id=4ecaca96&scoped=true&ts=true"
import script from "./OtherBill.vue?vue&type=script&lang=ts"
export * from "./OtherBill.vue?vue&type=script&lang=ts"

import "./OtherBill.vue?vue&type=style&index=0&id=4ecaca96&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecaca96"]])

export default __exports__